export const noop = () => {};

export const mod = (x: number, n: number) => ((x % n) + n) % n;

export const padStartZero = (value: number, length = 2): string => String(value).padStart(length, '0');

export const isNil = (value: unknown): value is null | undefined => value == null;
